import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { Button, Result } from 'antd';
import {
  CRow,
  CCard,
  CCardHeader,
  CCol
} from '@coreui/react';

const NotFound = () => {
  const navigate = useNavigate();
  const [seconds, setSeconds] = useState(10);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(prev => prev - 1);
    }, 1000);
    
    const timeout = setTimeout(() => {
      navigate("/");
    }, 10000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [navigate]);

  return (
    <CRow>
      <CCard className="mb-4">
        <CCardHeader>
          <CCol xs={12}>
            <hr />
            <Result
              status="404"
              title="404"
              subTitle="Désolé, cette page est introuvable !"
              extra={
                <div>
                  <Button type="primary" onClick={() => navigate("/")}>Accueil</Button>
                  <br />
                  <span style={{ marginLeft: '10px', fontSize: '16px', fontWeight: 'bold' }}>
                    <p>Redirection dans {seconds}...</p>
                  </span>
                  
                </div>
              }
            />
            <hr />
          </CCol>
        </CCardHeader>
      </CCard>
    </CRow>
  );
};

export default NotFound;
